"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBreakpoints = exports.defaultDeviceMatchesMap = void 0;
var _react = require("react");
var _breakpoints = require("../layout/breakpoints");
var _BreakpointsProvider = require("../system/BreakpointsProvider");
var _browser = require("../utils/browser");
var _globalMatchMediaListener = require("../utils/globalMatchMediaListener");
const booleanDeviceNames = {
  phone: 'isPhone',
  phoneLandscape: 'isPhoneLandscape',
  tablet: 'isTablet',
  tabletLandscape: 'isTabletLandscape',
  desktop: 'isDesktop',
  desktopLarge: 'isDesktopLarge',
  extraWide: 'isExtraWide'
};
const defaultDeviceMatchesMap = {
  phone: {
    isPhone: true,
    isPhoneLandscape: false,
    isTablet: false,
    isTabletLandscape: false,
    isDesktop: false,
    isDesktopLarge: false,
    isExtraWide: false
  },
  tablet: {
    isPhone: false,
    isPhoneLandscape: false,
    isTablet: true,
    isTabletLandscape: false,
    isDesktop: false,
    isDesktopLarge: false,
    isExtraWide: false
  },
  desktop: {
    isPhone: false,
    isPhoneLandscape: false,
    isTablet: false,
    isTabletLandscape: false,
    isDesktop: true,
    isDesktopLarge: false,
    isExtraWide: false
  }
};
exports.defaultDeviceMatchesMap = defaultDeviceMatchesMap;
const deviceKeys = Object.keys(_breakpoints.deviceMqRanges);

/**
 * Only use this hook to conditionally render large component trees or logic
 * @danger do not use this hook to conditionally render styles, please use responsiveConfig instead
 * @returns isPhone, isPhoneLandscape, isTablet, isTabletLandscape, isDesktop, isDesktopLarge, isExtraWide
 */
const useBreakpoints = () => {
  const defaultDevice = (0, _BreakpointsProvider.useDefaultBreakpointContext)();
  const matchesMediaQuery = (0, _react.useCallback)(mediaQuery => {
    var _getBrowserGlobals, _getBrowserGlobals$wi;
    return (_getBrowserGlobals = (0, _browser.getBrowserGlobals)()) === null || _getBrowserGlobals === void 0 ? void 0 : (_getBrowserGlobals$wi = _getBrowserGlobals.window) === null || _getBrowserGlobals$wi === void 0 ? void 0 : _getBrowserGlobals$wi.matchMedia(mediaQuery);
  }, []);
  const getMatches = (0, _react.useCallback)(() => {
    const matches = {};
    deviceKeys.forEach(device => {
      var _matchesMediaQuery$ma, _matchesMediaQuery;
      const deviceQuery = _breakpoints.deviceMqRanges[device];
      matches[booleanDeviceNames[device]] = (_matchesMediaQuery$ma = (_matchesMediaQuery = matchesMediaQuery(deviceQuery)) === null || _matchesMediaQuery === void 0 ? void 0 : _matchesMediaQuery.matches) !== null && _matchesMediaQuery$ma !== void 0 ? _matchesMediaQuery$ma : false;
    });
    return matches;
  }, [matchesMediaQuery]);
  const initialMatches = getMatches();
  const initialState = defaultDevice ? defaultDeviceMatchesMap[defaultDevice] : initialMatches;
  const _useState = (0, _react.useState)(initialState),
    deviceMatches = _useState[0],
    setDeviceMatches = _useState[1];
  const setMatches = (0, _react.useCallback)(() => {
    const matches = getMatches();
    setDeviceMatches(matches);
  }, [getMatches]);
  (0, _react.useEffect)(() => {
    deviceKeys.forEach(device => (0, _globalMatchMediaListener.addMatchMediaListener)(_breakpoints.deviceMqRanges[device], setMatches));
    return () => {
      deviceKeys.forEach(device => (0, _globalMatchMediaListener.removeMatchMediaListener)(_breakpoints.deviceMqRanges[device], setMatches));
    };
  }, [getMatches, matchesMediaQuery, setMatches]);
  return deviceMatches;
};
exports.useBreakpoints = useBreakpoints;